var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="CDB-Dashboard-mapWrapper js-map-wrapper">\n  <div class="CDB-Map-canvas">\n    <div class="CDB-Map" id="map"></div>\n  </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/dashboard.tpl
// module id = 914
// module chunks = 0 2